/**
 * 缓存说明:抄表系统业主管理
 */
import vm from '@/cache/storeTools.js'
import roleApi from '@/components/api/roleApi.js'
import meterReadingApi from '@/components/api/meterReading/meterReadingApi.js'
import workorderApi from '@/components/api/projectDingZhi/ningbo/workorderApi.js'

var basestate = {
    // 当前公司信息
    nowUnit: {},
    nowUser: {},
    isNullList: {
        rfid: [{
            required: true,
            message: '请输入业主ID',
            trigger: 'blur'
        }],
        username: [{
            required: true,
            message: '请输入业主姓名',
            trigger: 'blur'
        }],
        mobile: [{
            required: true,
            message: '请输入联系电话',
            trigger: 'blur'
        }],
        balanceAlarm: [{
            required: true,
            message: '请输入告警值',
            trigger: 'blur'
        }],
        cardNumbers: [{
            required: true,
            message: '请输入卡号',
            trigger: 'blur'
        }],
        usercode: [{
            required: true,
            message: '请输入登录名',
            trigger: 'blur'
        }],
        password: [{
            required: true,
            message: '请输入密码',
            trigger: 'blur'
        }],
        password2: [{
            required: true,
            message: '请输入确认密码',
            trigger: 'blur'
        }],
    }, //非空判断
    columns: [{
        name: '业主编号',
        key: 'rfid'
    }, {
        name: '姓名',
        key: 'username'
    }, {
        name: '联系方式',
        key: 'mobile'
    }, {
        name: '地址',
        key: 'address'
    }, {
        name: '性别',
        key: 'gender'
    }, {
        name: '账户余额(元)',
        key: 'balance',
        type: 'slot'
    }, {
        name: '是否关联电表',
        key: 'isBindDevice',
        type: 'slot'
    }, {
        name: '操作',
        key: 'operate',
        type: 'slot'
    }],
    deviceStatusList: [{
        label: '已关联',
        value: true
    }, {
        label: '未关联',
        value: false
    }],
    chargeModeList: [{
        text: '请选择',
        value: ''
    }, {
        text: '单价计费',
        value: 'SingleBilling'
    }, {
        text: '阶梯计费',
        value: 'StepBilling'
    }, {
        text: '费率计费',
        value: 'PeakAndValleyBilling'
    }],
    allRoles: [],
    ownerRoleId: '',
    allRfidList: [], // 已存在的业主编号
    bindedDeviceNos: [], // 已绑定业主的设备列表
    ownerEditing: {}, // 正在编辑的业主信息
    deviceNos: [], // 抄表设备no列表
    nowOwnerInformation: {}, //选中的业主信息
}

var store = new vm.Vuex.Store({
    state: copy(basestate),
    getters: {

    },
    mutations: {
        clear() {
            //清理缓存
            store.replaceState(copy(basestate))
        },
        setNowUnit(state, unit) {
            if (unit == undefined) {
                return
            }
            vm.Vue.set(state, 'nowUnit', unit)
            store.commit('getAllOwnerRfidList') //计费方式
            store.commit('getDeviceNos', unit.id) //获取单位下所有电表
        },
        getAllRoles(state) {
            roleApi.getAllRole(respon => {
                vm.Vue.set(state, 'allRoles', respon)
                for (let i = 0; i < respon.length; i++) {
                    if (respon[i].rolename == '业主') {
                        vm.Vue.set(state, 'ownerRoleId', respon[i].id)
                    }
                }
            })
        },
        getAllOwnerRfidList(state) {
            meterReadingApi.getAllBindOwnerDeviceNo(respon => {
                vm.Vue.set(state, 'allRfidList', respon)
            })
        },
        getBindedDeviceNos(state) {
            meterReadingApi.getAllBindOwnerDeviceNo(respon => {
                vm.Vue.set(state, 'bindedDeviceNos', respon)
            })
        },
        // 设置待编辑业主绑定的设备
        setOwnerEditing(state, ownerInfo) {
            vm.Vue.set(state, 'ownerEditing', {})
            if (!isempty(ownerInfo)) {
                vm.Vue.set(state, 'ownerEditing', ownerInfo)
            }
        },
        // 获取单位下所有的抄表列表
        getDeviceNos(state, unitId) {
            vm.Vue.set(state, 'deviceNos', [])
            meterReadingApi.getMeterReadingConfigListByUnitId(unitId, respon => {
                if (isempty(respon)) {
                    return
                }
                var deviceNos = []
                for (let i = 0; i < respon.length; i++) {
                    deviceNos.push(respon[i].deviceNo)
                }
                vm.Vue.set(state, 'deviceNos', deviceNos)
            })
        },
    }
});

//对外提供
export default store